<div class="h-100 d-flex flex-column" [class.d-none]="!this.validCatalog">
	<div class="header-height">
		<app-mobile-header [showInfoletter]="true" [theme]="'neutral'" [showWatchlist]="true" [catalogKey]="catalogKey" />
	</div>
	<main class="h-100 overflow-hidden">
		@switch (currentMobileView) {
			@case (mobileButtonType.CatalogTree) {
				@if (isSearch) {
					@defer (on immediate) {
						<app-catalog-mobile-search-tree [catalog]="catalog" [catalogKey]="catalogKey" />
					}
				} @else {
					@defer (on immediate) {
						<app-catalog-mobile-tree [catalog]="catalog" [catalogKey]="catalogKey" />
					}
				}
			}
			@case (mobileButtonType.CatalogDetails) {
				<!-- Ohne @defer: dieser Zweig rendert /catalog/<key>/catalogItem/<guid>, einen der
				     beiden gecrawlten Pfade. Ein @defer kostete hier eine eigene Netzrunde. -->
				<app-catalog-mobile-details [catalog]="catalog" [catalogKey]="catalogKey" />
			}
			@case (mobileButtonType.SearchInput) {
				@defer (on immediate) {
					<app-catalog-mobile-search [catalog]="catalog" [catalogKey]="catalogKey" />
				}
			}
			@case (mobileButtonType.Infocenter) {
				@defer (on immediate) {
					<app-catalog-mobile-news [catalog]="catalog" />
				}
			}
			@default {
				@if (currentMobileView === mobileButtonType.CatalogContact || currentMobileView === mobileButtonType.CatalogInfo) {
					<!-- Ohne @defer: dieser Zweig rendert /catalog/<key>, den zweiten gecrawlten Pfad. -->
					<app-catalog-mobile-info [catalog]="catalog" [catalogKey]="catalogKey" />
				}
			}
		}
	</main>
	<div class="flex-grow-1">
		<app-mobile-bar
			#mobileBar
			[disabledMobileBarButtons]="disabledMobileBarButtons"
			[initMobileBarButton]="initMobileBarButton"
			[mobileBarButtons]="mobileBarButtons"
			(buttonChanged)="currentMobileView = $event"></app-mobile-bar>
	</div>
</div>
@if (!validCatalog) {
	@defer (on immediate) {
		<app-catalog-not-found />
	}
}
